'use client';

import { useNavbar } from '@/hooks/useNavbar';
import NavbarServer from './server';
import type { NavbarClientProps } from './type';

export function NavbarClient({
  hideBadge,
  showFreeCaseReviewButton = true,
  showTalkToSpecialistButton = true,
  claimSections,
  initialTop,
  minTop,
  className,
  ctaAction,
  ctaHref,
  navLinks,
  phone,
}: NavbarClientProps) {
  const {
    isScrolled,
    isMenuOpen,
    toggleMenuOpen,
    top,
    transitionToTop,
    isMobile,
    bottom,
    scrollToForm,
  } = useNavbar(initialTop, minTop);
  return (
    <NavbarServer
      top={top}
      initialTop={initialTop}
      transitionToTop={transitionToTop}
      isScrolled={isScrolled}
      isMenuOpen={isMenuOpen}
      onToggleMenuOpen={toggleMenuOpen}
      hideBadge={hideBadge}
      showFreeCaseReviewButton={showFreeCaseReviewButton}
      showTalkToSpecialistButton={showTalkToSpecialistButton}
      claimSections={claimSections}
      isMobile={isMobile}
      bottom={bottom}
      className={className}
      onClickCta={ctaAction === 'scroll_to_form' ? scrollToForm : undefined}
      ctaHref={ctaHref}
      navLinks={navLinks}
      phone={phone}
    />
  );
}

export default NavbarClient;
